module.exports = __webpack_public_path__ + "custom-config/img/certification@2x.b42e1c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/certification@2x.png
// module id = 0+am
// module chunks = 2 3 4 6 7 8 9